import log from 'salvo-lite/log'

class InViewport {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._target = elem.getAttribute('data-in-viewport') || null
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._checkStatus()
        document.addEventListener('scroll', (event) => {
            this._checkStatus()
        })
    }
    _checkStatus () {
        if (this._inViewport(this._elem)) {
            if (this._target) {
                document.querySelector(this._target).classList.add('in-viewport')
            } else {
                this._elem.classList.add('in-viewport')
            }
        } else {
            if (this._target) {
                document.querySelector(this._target).classList.remove('in-viewport')
            } else {
                this._elem.classList.remove('in-viewport')
            }
        }
        if (this._beenInViewport(this._elem)) {
            if (this._target) {
                document.querySelector(this._target).classList.add('been-in-viewport')
            } else {
                this._elem.classList.add('benn-in-viewport')
            }
        } else {
            if (this._target) {
                document.querySelector(this._target).classList.remove('been-in-viewport')
            } else {
                this._elem.classList.remove('been-in-viewport')
            }
        }
    }
    _inViewport (element) {
        var bb = element.getBoundingClientRect()
        return (bb.top < window.innerHeight)
    }
    _beenInViewport (element) {
        var bb = element.getBoundingClientRect()
        return (bb.bottom < 0)
    }
}

export default InViewport



// WEBPACK FOOTER //
// ./src/resources/scripts/components/InViewport.js